import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { DashboardProfileContextService } from '@rma/dashboard/authentication/public/user';
import { map } from 'rxjs';

export const assistantCanActiveGuard: CanActivateFn = () => {
  const dashboardProfileContextService = inject(DashboardProfileContextService);
  const router = inject(Router);

  return dashboardProfileContextService.isAssistant$.pipe(
    map((isAssistant) => {
      if (!isAssistant) {
        return true;
      }

      return new RedirectCommand(router.parseUrl('no-assistant-access'), {
        skipLocationChange: true,
      });
    }),
  );
};
